import { useEffect, useState } from 'react';
import { alCambiar, cantidadPendiente, sincronizar } from '../../lib/colaOffline';

/**
 * Avisa que hay registros anotados sin señal, esperando subir.
 *
 * Sin esto, alguien que anota un pañal a las 3 de la mañana sin
 * cobertura no tiene forma de saber si se guardó o se perdió — y esa
 * duda es peor que el problema, porque termina anotando dos veces o
 * dejando de confiar en la app.
 *
 * No aparece cuando no hay nada pendiente, que es casi siempre.
 */
export default function IndicadorPendientes() {
  const [cantidad, setCantidad] = useState(cantidadPendiente());
  const [subiendo, setSubiendo] = useState(false);
  const [sinConexion, setSinConexion] = useState(
    typeof navigator !== 'undefined' ? !navigator.onLine : false,
  );

  useEffect(() => {
    const quitar = alCambiar(setCantidad);

    const online = () => setSinConexion(false);
    const offline = () => setSinConexion(true);
    window.addEventListener('online', online);
    window.addEventListener('offline', offline);

    return () => {
      quitar();
      window.removeEventListener('online', online);
      window.removeEventListener('offline', offline);
    };
  }, []);

  if (cantidad === 0) return null;

  const subirAhora = async () => {
    setSubiendo(true);
    try {
      await sincronizar();
    } finally {
      setSubiendo(false);
      setCantidad(cantidadPendiente());
    }
  };

  return (
    <div className="mx-4 mb-4 rounded-2xl border border-sky-200 bg-sky-50 px-4 py-3">
      <div className="flex items-center gap-3">
        <i className="ri-cloud-off-line text-xl text-sky-600"></i>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-sky-900">
            {cantidad} {cantidad === 1 ? 'registro guardado' : 'registros guardados'} en el celular
          </p>
          <p className="text-xs text-sky-700">
            {sinConexion
              ? 'Se subirán solos cuando vuelva el internet.'
              : 'Subiéndolos…'}
          </p>
        </div>
        {!sinConexion && (
          <button
            onClick={subirAhora}
            disabled={subiendo}
            className="text-xs font-medium text-sky-800 border border-sky-300 rounded-lg px-3 py-1.5 hover:bg-sky-100 disabled:opacity-50 transition-colors"
          >
            {subiendo ? 'Subiendo…' : 'Subir ahora'}
          </button>
        )}
      </div>
    </div>
  );
}
